//支付成功，调用跳转接口，后端进行跳转
import api from '../../api/api';
import UnifiedApi from '../../assets/js/UnifiedApi';

async function PayJump(prePayId,payTicket){
    let res =  await UnifiedApi({
        api:api.payJump,
        fn:function(){PayJump(prePayId,payTicket)},
        params:{payTicket:payTicket, method:'member',devId:'WEB',},
        urlParams:prePayId,
    });
    if(res.data && typeof res.data =='string'){
        return res.data;
    }else{
        PayJump(prePayId,payTicket);
    }
}
export default PayJump